import React, { useState } from 'react';
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    FormControlLabel,

    FormControl,
    InputLabel,
    Select,
    ListItemText,
    Input
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { AiOutlineSearch } from "react-icons/ai";
import { Card, Alert } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import success from "../../assets/img/success.png";
import FileBase64 from "../../components/Upload/UploadFile";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import EditIcon from "@mui/icons-material/Edit";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import { makeStyles } from "@mui/styles";
import { partnerCountryList } from '../../redux/actions/countryListForPartnerAction';
// import { partnerAddNewBankList } from "../../redux/actions/addNewBankInPartnerAction";
import { partnerGetMappingBankAllList } from "../../redux/actions/getMappingBankAllListAction";
import { partnerDeleteBankMapping } from '../../redux/actions/deleteBankMappingForPartnerAction';
import { partnerGetMappingBankName } from "../../redux/actions/getMappingBankNameListAction";
import { partnerBankListReqList } from "../../redux/actions/bankListForPartnerAction";
import { partnerMappingBanksReqList } from "../../redux/actions/mappingBanksForPartnerAction";
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const PartnerBankMaster = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const [addOpen, setAddOpen] = useState(false);
    const [openMappingBanks, setOpenMappingBanks] = useState(false)

    const [selectedCountry, setselectedCountry] = useState('');
    const [selectedCountryMap, setSelectedCountryMap] = useState('');

    const [getBankName, setGetBankName] = useState([])

    const [BankName, setBankName] = useState([]);


    const [getMappingBankName, setGetMappingBankName] = useState([])

    const [getBankListStatus, setGetBankListStatus] = useState(false);
    const [getBankListArray, setGetBankListArray] = useState("");

    const [getBankNameListStatus, setGetBankNameListStatus] = useState(false);
    const [getBankNameListArray, setGetBankNameListArray] = useState([]);



    const [BankListStatus, setBankListStatus] = useState(false);
    const [BankListArray, setBankListArray] = useState([]);

    const [mapBankStatus, setMapBankStatus] =
        useState(false);
    const [mapBankStatusResArray, setMapBankStatusResArray] =
        useState("");

    const [addNewBankResp, setAddNewBankResp] = useState(false);

    const [deleteMappingBankStatus, setDeleteMappingBankStatus] = useState(false)
    const [deleteMappingBankArray, setDeleteMappingBankArray] = useState("")
    const [deleteOpen, setDeleteOpen] = useState(false)
    const [code, setCode] = useState("");
    const [deleteNotification, setDeleteNotification] = useState(false)

    const [countryList, setcountryList] = useState([])
    const [countryModalList, setcountryModalList] = useState([])

    const [isLoading, setIsLoading] = useState(true);
    const [respDescriptionAddUpdate, setrespDescriptionAddUpdate] = useState('');

    const [nidFrontsName, setNidFrontsName] = useState("");
    const [nidFronts, setNidFronts] = useState("");

    const [addCountry, setaddCountry] = useState('');
    const [addBankName, setaddBankName] = useState('');

    const [getBankType, setGetBankType] = useState('')

    const [UploadFileName, setUploadFileName] = useState("");
    const [uploadFile, setUploadFile] = useState("");

    const [notificationOpen, setnotificationOpen] = useState(false);
    const [checkListNotification, setCheckListNotification] = useState(false)



    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    var authToken = regenerateTokenRes.data.AuthToken;

    const getCountryListRes = useSelector(({ countryListsForPartner }) => countryListsForPartner);
    const PartnerAddNewBankRes = useSelector(({ addNewBanksListsInPartner }) => addNewBanksListsInPartner);
    const PartnerGetMappingBankAllListRes = useSelector(({ getMappingBanksAllLists }) => getMappingBanksAllLists)
    const deletebankMappingForPartnerRes = useSelector(({ deleteBanksMappingsForPartner }) => deleteBanksMappingsForPartner);

    const getBankNameListRes = useSelector(({ getMappingBanksNamesLists }) => getMappingBanksNamesLists);
    const bankNameListRes = useSelector(({ banksListsForPartner }) => banksListsForPartner)
    const partnerMappingBanksRes = useSelector(({ mappingsBankListsForPartner }) => mappingsBankListsForPartner)
    const classes = useStyles();
    const dispatch = useDispatch();
    const getCountryResp = () => {
        if (getCountryListRes.data.status === 'success') {
            setIsLoading(false);
            setcountryList(getCountryListRes.data.list);
        }
    }

    useEffect(() => {
        getCountryResp();
    }, [getCountryListRes.data.status]);
    useEffect(() => {
        getCountryListListReq()
    }, []);

    const getCountryListListReq = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                bankType: "local"

            }
        }
        dispatch(partnerCountryList(req, authToken));
        setGetBankType()
    };

    const getBankNameListReq = () => {
        setGetBankNameListStatus(true)
        const Request = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                country: selectedCountry,

            }
        }
        dispatch(partnerGetMappingBankName(Request, authToken));

    }

    const getBankNameListFunc = () => {
        if (getBankNameListStatus) {
            if (getBankNameListRes.data.status == "success") {
                setGetBankNameListArray(getBankNameListRes.data.customerMasterDetailsRequestVOList);
            }
            if (getBankNameListRes.data.status == "failed") {
                setGetBankNameListArray(getBankNameListRes.data);
            }
        }
    };

    useEffect(() => {
        if (selectedCountry) {
            getBankNameListReq()
        }
    }, [selectedCountry])

    useEffect(() => {
        getBankNameListFunc()
    }, [getBankNameListRes.data.status])


    useEffect(() => {
        setGetBankName('')
    }, [selectedCountry])


    const handleChange = ({ target: { name, value } }) => {

        if (name === "countryList") {
            setselectedCountry(value === "Select Country" ? "" : value);
           
            
            // console.log('Selected Country: ', value);
        }
        if (name === "getBankName") {
            // setBankName(value)
            setGetBankName(value == "Select Bank" ? "" : value);

        }
        if (name === "countryModalList") {

            setSelectedCountryMap(value === "Select Country" ? "" : value);
            if(value == "Select Country"){
                setBankName([])
            }

            // console.log('Selected Country: ', value);            
        }
        if (name === "BankName") {
            // setBankName(value)
            setBankName(value == "Select Bank" ? "" : value);

        }

    };
    const onInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'addCountry') {
            setaddCountry(value);
        }
        if (name === 'addBankName') {
            setaddBankName(value)
        }


    }
    // const addBankModalOpen = () => {
    //     setAddOpen(true);
    //     // setaddCountry('')
    //     setselectedCountry('')
    //     // setaddBankName('')
    //     setUploadFileName('')
    // }

    const openManageBank = () => {
        setOpenMappingBanks(true)
        // setselectedCountry('')
        setSelectedCountryMap('')
        // setaddBankName('')
    }
    const handleAttachmentsDoc = (e, uploadFile, nidFronts) => {
        if (uploadFile == "uploadFile") {
            setUploadFile(e.base64);
            setUploadFileName(e.name);

        }
        else if (uploadFile == "nidFronts") {
            setNidFronts(e.base64);
            setNidFrontsName(e.name);
        }

    };
    const [isSaveDisabled, setIsSaveDisabled] = useState(true);

    useEffect(() => {
      if (selectedCountryMap && BankName.length > 0) {
        setIsSaveDisabled(false);
      } else {
        setIsSaveDisabled(true);
      }
    }, [selectedCountryMap, BankName]);


    const handleClose = () => {
        setAddOpen(false);
        setDeleteOpen(false);
        setOpenMappingBanks(false)


    }
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const partnerGetMappingBankAllListReq = () => {
        setIsLoading(true);
        setGetBankListStatus(true);

        let searchReq = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                country: selectedCountry,
                bankName: getBankName
            }
        }
        dispatch(partnerGetMappingBankAllList(searchReq, authToken));

    }

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            partnerGetMappingBankAllListReq();
        }
    }, [regenerateTokenRes.data.status]);


    const partnerGetMappingBankAllListFunc = () => {
        if (getBankListStatus) {
            if (PartnerGetMappingBankAllListRes.data.status == "success") {
                // console.log('Arr: ', PartnerGetMappingBankAllListRes.data.customerMasterDetailsRequestVOList)
                // console.log("map bank list", getBankListArray)
                setGetBankListArray([].concat(PartnerGetMappingBankAllListRes.data.customerMasterDetailsRequestVOList));
                setIsLoading(false);

            }
            if (PartnerGetMappingBankAllListRes.data.status == "failed") {
                setGetBankListArray(PartnerGetMappingBankAllListRes.data);
                setIsLoading(false);

            }
            if (PartnerGetMappingBankAllListRes.data.status == "NOT FOUND") {
                setGetBankListArray(PartnerGetMappingBankAllListRes.data)
                setIsLoading(false)
            }
        }
    }
    useEffect(() => {
        partnerGetMappingBankAllListFunc();
    }, [PartnerGetMappingBankAllListRes.data.status]);

    useEffect(() => {
		if (PartnerGetMappingBankAllListRes.data.status == "success") {
			setPage(0);
		}
	}, [PartnerGetMappingBankAllListRes.data.status]);

    const deleteUserFunc = (code) => {

        setCode(code)
        setDeleteOpen(true);
    };

    const deleteMappingbankReq = () => {
        setDeleteMappingBankStatus(true)
        let req = {
            actionCustomerMasterRequestVO: {

                walletOwnerId: regenerateTokenRes.data.partnerId,
                mappingId: code
            }
        }
        dispatch(partnerDeleteBankMapping(req, authToken));
        setDeleteOpen(false)
    }

    const deleteMappingBankFunc = () => {
        if (deleteMappingBankStatus) {
            if (deletebankMappingForPartnerRes.data.status == "success") {
                setDeleteMappingBankArray(deletebankMappingForPartnerRes.data)
                setDeleteNotification(true)
                partnerGetMappingBankAllListReq()

            }
            if (deletebankMappingForPartnerRes.data.status == "failed") {
                setDeleteMappingBankArray(deletebankMappingForPartnerRes.data)
                setDeleteNotification(true)
            }
        }
    }

    useEffect(() => {
        deleteMappingBankFunc()
    }, [deletebankMappingForPartnerRes.data.status])

    // const addNewBankInPartnerReq = () => {
    //     setAddNewBankResp(true);
    //     const addNewBankReq = {
    //         actionCustomerMasterRequestVO: {
    //             walletOwnerId: regenerateTokenRes.data.partnerId,
    //             country: selectedCountry,
    //             bankName: addBankName,
    //             qrCode: uploadFile.split(",")[1] || "-"
    //         }
    //     }
    //     dispatch(partnerAddNewBankList(addNewBankReq, authToken));
    //     setAddOpen(false)
    // }

    // const addNewBankRespFunc = () => {
    //     if (addNewBankResp) {
    //         if (PartnerAddNewBankRes.data.status === 'sucess') {
    //             setrespDescriptionAddUpdate(PartnerAddNewBankRes.data.description);
    //             setnotificationOpen(true);
    //             // adminGetBankReq()
    //             partnerGetMappingBankAllListReq()

    //         }
    //         if (PartnerAddNewBankRes.data.status === 'failed') {
    //             setrespDescriptionAddUpdate(PartnerAddNewBankRes.data.description);
    //             setnotificationOpen(true);
    //         }
    //     }
    // }

    // useEffect(() => {
    //     addNewBankRespFunc()
    // }, [PartnerAddNewBankRes.data.status]);



    const handleNoticationClose = () => {
        setnotificationOpen(false);
        setrespDescriptionAddUpdate('');
        setDeleteNotification(false);
        setCheckListNotification(false);
        setOpenMappingBanks(false)
        setBankName('')

    }
    //inside modal
    const getBankListReq = () => {
        setBankListStatus(true)
        const req = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                country: selectedCountryMap,

            }
        }
        dispatch(partnerBankListReqList(req, authToken));

    }
    const [filteredBanks, setFilteredBanks] = useState("")
    const FinalMapsdown = () => {

        // console.log("getBankmmmm", getBankListArray)
        if (bankNameListRes.data.customerMasterDetailsRequestVOList.length > 0) {
            const filterTypes = bankNameListRes.data.customerMasterDetailsRequestVOList
                .filter(bank => bank.countryName === selectedCountryMap)
                .map(bank => ({ name: bank.bankName, country: bank.countryName, id: bank.id }));
            const filteredBanksList = filterTypes.filter(bank => {

                return ![].concat(getBankListArray).some(firstBank => firstBank.bankName === bank.name && firstBank.country === bank.country);
            });
            setFilteredBanks([].concat(filteredBanksList))
        }

        else if (typeof bankNameListRes.data.customerMasterDetailsRequestVOList == "object") {
            let custDetails = [];
            custDetails.push(bankNameListRes.data.customerMasterDetailsRequestVOList);
            // console.log("cust", custDetails)
            const filterTypes = custDetails
                .filter(bank => bank.countryName === selectedCountryMap)
                .map(bank => ({ name: bank.bankName, country: bank.countryName, id: bank.id }));
            const filteredBanksList = filterTypes.filter(bank => {
                return !getBankListArray.some(firstBank => firstBank.bankName === bank.name && firstBank.country === bank.country);
            });
            setFilteredBanks([].concat(filteredBanksList))
        }

    }

    // let filteredBanks;
    const BankListFunc = () => {
        if (BankListStatus) {
            if (bankNameListRes.data.status == "success") {
                setBankListArray([].concat(bankNameListRes.data.customerMasterDetailsRequestVOList));
                // console.log("bbbbbAAAnnk", BankListArray)
                FinalMapsdown()
                // const filterTypes = bankNameListRes.data.customerMasterDetailsRequestVOList
                //     .filter(bank => bank.countryName === selectedCountryMap)
                //     .map(bank => ({ name: bank.bankName, country: bank.countryName, id: bank.id }));
                // const filteredBanksList = filterTypes.filter(bank => {
                //     return !getBankListArray.some(firstBank => firstBank.bankName === bank.name && firstBank.country === bank.country);

                // });
                // setFilteredBanks([].concat(filteredBanksList))
                // console.log("filterban", filteredBanks)
                // mainDropdown(selectedCountryMap)
                // let arrtwo = bankNameListRes.data.customerMasterDetailsRequestVOList;
                // finalMapDown();
                // setBankDropDown()
                // setGetBankListArray([].concat(PartnerGetMappingBankAllListRes.data.customerMasterDetailsRequestVOList));
            }
            if (bankNameListRes.data.status == "failed") {
                setBankListArray(bankNameListRes.data);
            }
        }
    };

    useEffect(() => {
        if (selectedCountryMap) {
            getBankListReq()
            // setBankListArray('')
        }
    }, [selectedCountryMap])

    useEffect(() => {
        BankListFunc()
    }, [bankNameListRes.data.status])


    useEffect(() => {
        // setBankName('')
    }, [selectedCountryMap])

    const getCountryModalResp = () => {
        if (getCountryListRes.data.status === 'success') {
            // setIsLoading(false);
            setcountryModalList(getCountryListRes.data.list);
        }
    }

    useEffect(() => {
        getCountryModalResp();
    }, [getCountryListRes.data.status]);
    useEffect(() => {
        getCountryListListReq()
    }, []);

    // BankListArray
    // getBankListArray

    // const finalMap = (a, b) => {
    //     console.log('Executing')
    //     const one = a.map(x => x.bankName);
    //     const two = b.map(x => x.bankName);
    //     let fa = [];
    //     for (let i = 0; i < a.length; i++) {
    //         if (JSON.stringify(one[i]) != JSON.stringify(two[i])) {
    //             fa.push(two[i])
    //         }
    //     }
    //     console.log(`fa: `, fa);
    // }

    // const finalMapDropDown = (a, b) => {
    //     console.log('Executing', a, b)
    //     const one = a.map(x => x.bankName);
    //     const two = b.map(x => x.bankName);
    //     console.log('One: ', one)
    //     console.log('Two: ', two)
    //     let fa = [];
    //     for (let i = 0; i < (a.length > b.length ? a.length : b.length); i++) {
    //         if (!two.includes(one[i])) {
    //             fa.push(one[i])
    //         }
    //     }
    //     console.log(`fa: `, fa);
    //     return fa
    // }
    // const [bankDropDown, setBankDropDown] = useState("")
    // const finalMapDown = () => {
    //     // const one = a.map(x => x.bankName);
    //     // const two = b.map(x => x.bankName);
    //     // console.log('One: ', one)
    //     // console.log('Two: ', two)
    //     let da = [];
    //     let j = 0;
    //     for (let i = 0; i < getBankListArray.length; i++) {
    //         j = 0;
    //         for (j = 0; j < BankListArray.length; j++) {
    //             if (getBankListArray[i].bankName == BankListArray[j].bankName) {
    //                 break
    //             }
    //             console.log("break")
    //         }
    //         if (j === BankListArray.length && getBankListArray[i].country != "India")
    //             da.push(getBankListArray[i])
    //     }
    //     console.log("banksDDropdown", bankDropDown)
    //     console.log(da)
    // }

    const getMappingBankReq = () => {
        const getIda = (ma, ar) => {
            // console.log("main", ar)
            let fa = [];
            const bn = [].concat(ma).map(x => x.name);
            for (let i = 0; i < ar.length; i++) {
                fa.push([].concat(ma)[bn.indexOf(ar[i])].id)
            }
            return fa
        }

        setMapBankStatus(true)
        let reqMap = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,

                // mappingIdList: BankName.length == 0 ? '' : BankName.map(x => { return x.split('-')[0] })
                mappingIdList: getIda(filteredBanks, BankName).length == 0 ? '' : getIda(filteredBanks, BankName)

            }
        }
        dispatch(partnerMappingBanksReqList(reqMap, authToken));

    }

    const checkBankNameFunc = () => {
        if (mapBankStatus) {
            if (partnerMappingBanksRes.data.status == "success") {
                setMapBankStatusResArray(partnerMappingBanksRes.data)
                setCheckListNotification(true)
                // setBankName('')
                partnerGetMappingBankAllListReq()


            }
            if (partnerMappingBanksRes.data.status == "failed") {
                setMapBankStatusResArray(partnerMappingBanksRes.data)
                setCheckListNotification(true)
            }
        }
    }
    useEffect(() => {
        checkBankNameFunc()
    }, [partnerMappingBanksRes.data.status])
    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        style={{
                            padding: "25px",
                            // marginTop: "1rem",
                            // marginLeft: "1rem",
                            gap: "20px",
                            justifyContent: "right"
                        }}
                    >
                        <Grid item xs={12} md={4} sm={3} lg={5}></Grid>
                        {/* <Grid item xs={12} md={3} sm={3} lg={3}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={() => addBankModalOpen()}
                            >
                                Add New Bank
                            </CustomButton>
                        </Grid> */}
                        <Grid item xs={12} md={3} sm={3} lg={3}>
                            {/* <NavLink to="/index/adminMappingBank"> */}
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={() => openManageBank()}
                            >
                                Manage Bank
                            </CustomButton>
                            {/* </NavLink> */}
                        </Grid>
                    </Grid>


                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Country"
                                fullWidth={true}
                                name="countryList"
                                value={selectedCountry || ''}
                                onChange={handleChange}
                                variant='standard'
                                InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
                            >
                                <MenuItem
                                    value="Select Country"
                                    selected="Select Country"
                                >
                                    Select Country
                                </MenuItem>
                                {countryList &&
                                    [].concat(countryList).map((x) => (
                                        <MenuItem key={x.id} value={x.countryName}>
                                            {x.countryName}
                                        </MenuItem>
                                    ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Bank"
                                fullWidth={true}
                                name="getBankName"
                                value={getBankName || ''}
                                onChange={handleChange}
                                variant='standard'
                                InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}

                            >
                                <MenuItem
                                    value="Select Bank"
                                    selected="Select Bank"
                                >
                                    Select Bank
                                </MenuItem>

                                {getBankNameListRes.success &&
                                    [].concat(getBankNameListRes.data.customerMasterDetailsRequestVOList).map((x) => (
                                        <MenuItem value={x.bankName}>{x.bankName}</MenuItem>
                                    ))}

                            </TextField>
                        </Grid>
                        {/* <Grid item xs={12} sm={12} md={4} lg={4}>

                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Bank"
                                fullWidth={true}
                                name="countryList"
                                // value={selectedCountry || ''}
                                onChange={handleChange}
                            >
                                <MenuItem
                                    value="Select Country"
                                    selected="Select Country"
                                >
                                    Select Bank
                                </MenuItem> */}
                        {/* {countryList &&
                                    [].concat(countryList).map((x) => (
                                        <MenuItem key={x.id} value={x.countryName}>
                                            {x.countryName}
                                        </MenuItem>
                                    ))} */}
                        {/* </TextField>
                        </Grid> */}
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={partnerGetMappingBankAllListReq}
                            >
                                Search
                                <SearchIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (
                    <LoadingSpinner />
                ) : getBankListArray.length == undefined ||
                    !getBankListStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1" style={{ fontWeight: "700" }}>
                                    Summary Data
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <div>
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                                <Grid xs={12} sm={12} md={12} lg={12}>
                                    <Typography variant="body1" style={{ fontWeight: "700" }}>
                                        Report Table
                                    </Typography>
                                </Grid>
                                <TableContainer component={Paper} className="text-nowrap my-3">
                                    <Table className={classes.table}
                                        size="small"
                                        aria-label="a dense table"
                                    >
                                        <TableHead>
                                            <TableRow className="tableHeaderColor">
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Bank ID{" "}

                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Country ISO
                                                </TableCell>
                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Bank Name
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={{ fontWeight: "bold", color: "white" }}
                                                >
                                                    Action
                                                </TableCell>

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {getBankListArray &&
                                                []
                                                    .concat(getBankListArray)
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell align="center">
                                                                {row.bankId}
                                                            </TableCell>
                                                            <TableCell align="center">{row.countryISO}</TableCell>
                                                            <TableCell align="center">
                                                                {row.bankName}
                                                            </TableCell>


                                                            <TableCell align="center">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    // onClick={() => editModal(row.id, row.countryName, row.bankName, row.bankImage)}
                                                                    onClick={() =>
                                                                        deleteUserFunc(row.bankId)
                                                                    }

                                                                >
                                                                    <DeleteIcon style={{ color: "#fff" }} />
                                                                </CustomButton>
                                                            </TableCell>




                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={[].concat(getBankListArray).length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </TableContainer>
                            </Grid>
                        </Card>
                    </div>
                )}


            </Layout>


            {/* <div>
                <Dialog open={addOpen} onClose={handleClose}>
                    <DialogTitle style={{ minWidth: "600px" }}>
                        Add Bank
                    </DialogTitle>
                    <DialogContent>
                
                        <TextField
                            select
                            size="small"
                            color="primary"
                            type="text"
                            label="Country"
                            fullWidth={true}
                            name="countryList"
                            value={selectedCountry || ''}
                            onChange={handleChange}
                        >
                            <MenuItem
                                value="Select Country"
                                selected="Select Country"
                            >
                                Select Country
                            </MenuItem>
                            {countryList &&
                                [].concat(countryList).map((x) => (
                                    <MenuItem key={x.id} value={x.countryName}>
                                        {x.countryName}
                                    </MenuItem>
                                ))}
                        </TextField>


                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Bank Name"
                            fullWidth={true}
                            name="addBankName"
                            value={addBankName || ""}
                            onChange={onInputChange}
                        ></TextField>

                        <div style={{ marginTop: "1.5rem" }}>
                            {" "}
                            <Typography
                                variant="body1"
                                align="justify"
                                gutterBottom={true}
                                style={{ color: "#4f6c8d" }}
                            >
                                Upload
                            </Typography>
                            <FileBase64
                                multiple={false}
                                name={false}
                                id="documentGuard1"
                                accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
                                onDone={(e) => handleAttachmentsDoc(e, "uploadFile")}
                                showUploadList={false}
                                value={UploadFileName}
                            />
                            {UploadFileName ? UploadFileName : ""}
                        </div>

                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={addNewBankInPartnerReq}
                        >
                            Save
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div> */}

            <div>
                <Dialog open={deleteOpen} onClose={handleClose}>
                    <DialogTitle style={{ width: "400px" }}>Are you sure you want to delete?</DialogTitle>
                    <DialogActions className="p-3">
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                padding: "8px"
                            }}
                            // variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                padding: "8px",
                                width: "60px"
                            }}
                            onClick={deleteMappingbankReq}

                        >
                            Yes
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            <div>
                <Dialog open={openMappingBanks} onClose={handleClose}>
                    <DialogTitle style={{ minWidth: "600px" }}>
                        Mapping Bank
                    </DialogTitle>
                    <DialogContent>
                        {/* <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Country Name"
                            fullWidth={true}
                            name="addCountry"
                            value={addCountry || ""}
                            onChange={onInputChange}
                        ></TextField> */}
                        <TextField
                            select
                            size="small"
                            // color="primary"
                            className='countryLabel'
                            type="text"
                            label="Country"
                            fullWidth={true}
                            name="countryModalList"
                            value={selectedCountryMap || ''}
                            onChange={handleChange}
                            variant='standard'
                            InputProps={{
                                sx: {
                                  "&:before": { borderBottomColor: "gray" }, // before focus
                                  "&:after": { borderBottomColor: "gray" },  // after focus
                                },
                              }}
                              InputLabelProps={{
                                sx: { color: 'gray' }, // Optional: if you want the label to be white
                              }}
                        >
                            <MenuItem
                                value="Select Country"
                                selected="Select Country"
                            >
                                Select Country
                            </MenuItem>
                            {countryModalList &&
                                [].concat(countryModalList).map((x) => (
                                    <MenuItem key={x.id} value={x.countryName}>
                                        {x.countryName}
                                    </MenuItem>
                                ))}
                        </TextField>


                        {/* <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Bank Name"
                            fullWidth={true}
                            name="addBankName"
                            value={addBankName || ""}
                            onChange={onInputChange}
                        ></TextField> */}
                        {/* <Grid item xs={12} sm={12} md={4} lg={4}> */}

                        {/* <FormControl className={classes.formControl} style={{ width: '100%', marginTop: '-4px' }}> */}

                        <InputLabel id='multipleCountrySelect' style={{ margin: "10px 0 0 0" }}>Select Bank Name</InputLabel>
                        <Select
                            labelId='multipleCountrySelect'
                            multiple
                            size="small"
                            style={{ paddingTop: "none" }}
                            fullWidth={true}
                            value={BankName || []}
                            input={<Input />}
                            
                            renderValue={selected => selected.join(', ')}
                            onChange={handleChange}
                            name='BankName'
                            InputProps={{
                                sx: {
                                  "&:before": { borderBottomColor: "gray" }, // before focus
                                  "&:after": { borderBottomColor: "gray" },  // after focus
                                },
                              }}
                              InputLabelProps={{
                                sx: { color: 'gray' }, // Optional: if you want the label to be white
                              }}
                        >
                            {

                                filteredBanks && [].concat(filteredBanks).map((x, index) => {
                                    return (

                                        <MenuItem key={index} value={`${x.name}`}>
                                            <Checkbox color='primary' checked={BankName.indexOf(`${x.name}`) > -1} />
                                            <ListItemText primary={x.name} />
                                        </MenuItem>

                                    )
                                })
                            }



                        </Select>

                        {/* </FormControl> */}
                        {/* </Grid> */}


                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000",
                                color: "white"
                            }}
                            
                            variant="contained"
                            onClick={getMappingBankReq}
                            disabled={isSaveDisabled}
                        >  
                            Save
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            {deletebankMappingForPartnerRes.data.status == "success" && (
                <div>
                    <Dialog open={deleteNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteMappingBankArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}


            {deletebankMappingForPartnerRes.data.status == "failed" && (
                <div>
                    <Dialog open={deleteNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteMappingBankArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {PartnerAddNewBankRes.data.status == "sucess" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        {/* <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        > */}
                          <DialogContent
                            className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {respDescriptionAddUpdate}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {PartnerAddNewBankRes.data.status == "failed" && (
                <div>
                    <Dialog open={notificationOpen} onClose={handleNoticationClose}>
                        {/* <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        > */}
                          <DialogContent
                            className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {respDescriptionAddUpdate}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}


            {partnerMappingBanksRes.data.status == "success" && (
                <div>
                    <Dialog open={checkListNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {mapBankStatusResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {partnerMappingBanksRes.data.status == "failed" && (
                <div>
                    <Dialog open={checkListNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center"

						style={{ backgroundColor: "#00b9f51c" }}

                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {mapBankStatusResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default PartnerBankMaster